import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as CountriesActions from './countries.actions';
import { Country } from './countries.models';

export const COUNTRIES_FEATURE_KEY = 'countries';

export interface CountriesState extends EntityState<Country> {
  loaded: boolean;
  error?: unknown;
}

export interface CountriesPartialState {
  readonly [COUNTRIES_FEATURE_KEY]: CountriesState;
}

export const countriesAdapter: EntityAdapter<Country> = createEntityAdapter<Country>();
export const initialCountriesState: CountriesState = countriesAdapter.getInitialState({ loaded: false });
export const selectName = (country: Country) => country.name;
export const sortbyCodes = (countries: Country[], ...keys: string[]) => {
  for (const key of keys) {
    const index = countries.findIndex((country) => country.id === key);
    if (index !== -1) {
      const spliced = countries.splice(index, 1);
      countries.unshift(...spliced);
    }
  }
  return countries;
};

const reducer = createReducer(
  initialCountriesState,
  on(CountriesActions.initCountries, (state) => ({ ...state, loaded: false, error: null })),
  on(CountriesActions.loadCountriesSuccess, (state, { countries }) =>
    countriesAdapter.setAll(countries, { ...state, loaded: true })
  ),
  on(CountriesActions.loadCountriesFailure, (state, { error }) => ({ ...state, error }))
);

export function countriesReducer(state: CountriesState | undefined, action: Action) {
  return reducer(state, action);
}
